import { createReducer, on } from '@ngrx/store';
import { ExpenseVatActions } from './expense-vat.actions';
import { ExpenseVatItem } from '@core/interface/expense-vat';
import { Pagination } from '@core/interface/core';

export interface ExpenseVatState {
  expenseVats: ExpenseVatItem[];
  isLoading: boolean;
  isDeleted: boolean;
  loadError?: any;
  deleteError?: any;
  addEditError?: any;
  pagination: Pagination;
}

export const initialState: ExpenseVatState = {
  expenseVats: [],
  isLoading: true,
  isDeleted: false,
  pagination: {
    current_page: 1,
    last_page: 1,
    per_page: 10,
    total: 100,
  },
};

export const ExpenseVatReducer = createReducer(
  initialState,
  on(ExpenseVatActions.loadExpenseVats, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(ExpenseVatActions.loadExpenseVatsSuccess, (state, { data, pagination }) => ({
    ...state,
    pagination,
    expenseVats: data,
    isLoading: false,
    loadError: null,
  })),
  on(ExpenseVatActions.loadExpenseVatsFailure, (state, { error }) => ({
    ...state,
    loadError: error,
    isLoading: false,
    isDeleted: false,
  })),
  on(ExpenseVatActions.addExpenseVatSuccess, (state, { data }) => ({
    ...state,
    expenseVats: [...state.expenseVats, data],
    addEditError: null,
  })),
  on(ExpenseVatActions.addExpenseVatFailure, (state, error) => ({
    ...state,
    addEditError: error,
  })),
  on(ExpenseVatActions.updateExpenseVatSuccess, (state, { data }) => ({
    ...state,
    expenseVats: state.expenseVats.map((item) =>
      data.id == item.id ? data : item
    ),
    addEditError: null,
  })),
  on(ExpenseVatActions.updateExpenseVatFailure, (state, { error }) => ({
    ...state,
    addEditError: error,
  })),
  on(ExpenseVatActions.deleteExpenseVatSuccess, (state, { success, id }) => ({
    ...state,
    isDeleted: success,
    deleteError: null,
    expenseVats: state.expenseVats.filter((item) => item.id !== id),
  })),
  on(ExpenseVatActions.deleteExpenseVatFailure, (state, error) => ({
    ...state,
    isDeleted: false,
    deleteError: error,
  })),
  on(ExpenseVatActions.deleteExpenseVat, (state) => ({
    ...state,
    isDeleted: false,
    deleteError: null,
  })),
  on(ExpenseVatActions.resetDeleteStatus, (state) => ({
    ...state,
    isDeleted: false,
    deleteError: null,
  })),
  on(ExpenseVatActions.resetExpenseVats, (state) => ({
    ...state,
    pagination: {
      current_page: 0,
      last_page: 0,
      per_page: 10,
      total: 0,
    },
    expenseVats: [],
    isLoading: false,
  }))
);
